import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { schema } from "./schema";
import { useContext } from "react";
import { ContextRegisterCollaborator } from "../context";
import Notification from "../../../toast";
import reqColaborador from "../../../../services/reqMultiTenant/reqColaborador";

export const IndexHooks = () => {
	const {
		setCollaboratorData,
		setFilterData,
		openModalFilterCollaborator,
		currentPage,
		setPage,
		setTotalPage,
		setLoading,
	} = useContext(ContextRegisterCollaborator);
	const {
		handleSubmit,
		register,
		watch,
		setFocus,
		formState: { errors, isSubmitting },
		control,
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: {
			param: "nome",
			paramValue: "",
			active: true,
		},
	});

	const paramSelected = watch("param");

	const handleOnSubmit = async (data) => {
		await fetchCollaborator(data);
	};

	const fetchCollaborator = async (filterDataSelected) => {
		setLoading(true);
		try {
			const { param, paramValue, active } = filterDataSelected;

			let ativo = "NAO";
			if (active === true) ativo = "SIM";
			const response = await reqColaborador.listPaginate(param, paramValue, ativo, 1);

			const recordCount = response.data.length;

			setCollaboratorData(response.data);

			//se não encontrou nada esta na ultima pagina
			if (response.data.length < 15) {
				setTotalPage(1);
			} else {
				setTotalPage(0);
				currentPage.current = 1;
			}

			const filter = { ...filterDataSelected, ativo, recordCount };

			setFilterData(filter);
			setPage(1);

			closeModal();
		} catch (error) {
			setCollaboratorData([]);
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setLoading(false);
		}
	};

	const closeModal = () => {
		openModalFilterCollaborator((prevState) => !prevState);
	};

	return {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setFocus,
		control,
		Controller,
	};
};
